import { render, staticRenderFns } from "./SAccProjectUsers.vue?vue&type=template&id=4ad48db6&scoped=true"
import script from "./SAccProjectUsers.vue?vue&type=script&lang=ts"
export * from "./SAccProjectUsers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad48db6",
  null
  
)

export default component.exports